// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Container, Grid, Typography, Stack, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// project imports
import AppBar from 'ui-component/extended/AppBar';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import FooterSection from '../../../layout/MainLayout/Footer/FooterSection';
// assets
import headerBackground from 'assets/images/landing/bg-header.jpg';

const HeaderWrapper = styled('div')(({ theme }) => ({
    backgroundImage: `url(${headerBackground})`,
    backgroundSize: '100% 600px',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    textAlign: 'center',
    paddingTop: 30,
    [theme.breakpoints.down('md')]: {
        paddingTop: 0
    }
}));
const SectionWrapperFooter = styled('div')({
    paddingTop: 50,
    paddingBottom: 0
});
// ============================|| SAAS PAGES - PRIVCY POLICY ||============================ //

const TermOfUse = () => {
    const theme = useTheme();

    return (
        <HeaderWrapper>
            <AppBar />
            <Container>
                <Grid container justifyContent="center" spacing={gridSpacing}>
                    <Grid item sm={10} md={7} sx={{ mt: { md: 12.5, xs: 2.5 }, mb: { md: 8, xs: 2.5 } }}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Typography
                                    variant="h1"
                                    component="div"
                                    color="white"
                                    sx={{
                                        fontSize: '3.5rem',
                                        fontWeight: 900,
                                        lineHeight: 1.4,
                                        [theme.breakpoints.down('md')]: { fontSize: '1.8125rem', marginTop: '80px' }
                                    }}
                                >
                                    ĐIỀU KHOẢN SỬ DỤNG
                                </Typography>
                            </Grid>
                            <Grid item xs={12}></Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <MainCard elevation={4} border={false} boxShadow shadow={4} sx={{ mb: 3 }}>
                            <Stack spacing={2} sx={{ textAlign: 'left' }}>
                                <Typography variant="h4">Giới Thiệu: </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Chào mừng bạn đến với YouTeach.AI! Những Điều khoản và Điều kiện này ("Điều khoản") quy định việc bạn sử
                                    dụng YouTeach.AI và bất kỳ ứng dụng, phần mềm, và trang web liên quan nào (cùng được gọi là "Dịch vụ"
                                    của chúng tôi). Đây là một hợp đồng giữa bạn và Công ty YouTeach.AI, và bao gồm Chính sách Quyền riêng
                                    tư của chúng tôi. Bằng cách truy cập Dịch vụ của chúng tôi, bạn đồng ý với những Điều khoản này.
                                </Typography>

                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Vui lòng đọc{' '}
                                    <Link component={RouterLink} underline="hover" to="/pages/privacy-policy">
                                        Chính sách Quyền riêng tư
                                    </Link>{' '}
                                    của chúng tôi, mô tả cách chúng tôi thu thập và sử dụng thông tin cá nhân.
                                </Typography>

                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Lưu ý: Nếu bạn đang đại diện cho một tổ chức, công ty hoặc đơn vị khác, bạn phải có quyền lực để buộc
                                    đơn vị đó tuân thủ những Điều khoản này. Nếu bạn không có quyền lực đó, bạn không được sử dụng Dịch vụ
                                    của chúng tôi.
                                </Typography>
                                <Typography variant="h4">Về chúng tôi: </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    YouTeach.AI là một dịch vụ cho phép bạn tạo và chia sẻ chatbot tùy chỉnh sử dụng trí tuệ nhân tạo. Bạn
                                    có thể sử dụng Dịch vụ của chúng tôi để tích hợp nội dung riêng biệt của mình, từ tài liệu hỗ trợ đến
                                    thông tin trang web, và tận dụng khả năng độc đáo của ChatGPT-4 để nhận câu trả lời chính xác và hữu
                                    ích. Bạn có thể đặt câu hỏi, nhận được phản hồi chính xác, đáng tin cậy và tiếp tục mạch trò chuyện một
                                    cách tự nhiên, giúp doanh nghiệp nâng cao hiệu suất nhân viên và tương tác với khách hàng một cách hiệu
                                    quả, giúp tư vấn viên và học sinh, sinh viên tương tác một cách thông minh.
                                </Typography>
                                <Typography variant="h4">Tạo tài khoản và truy cập: </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Tuổi tối thiểu: Bạn phải ít nhất 16 tuổi hoặc độ tuổi tối thiểu cần thiết để đồng ý sử dụng Dịch vụ tại
                                    địa phương của bạn, tùy theo độ tuổi nào cao hơn.
                                </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Tài khoản YouTeach.AI của bạn. Để truy cập Dịch vụ của chúng tôi, chúng tôi có thể yêu cầu bạn tạo một
                                    tài khoản ("Tài khoản"). Bạn đồng ý cung cấp thông tin Tài khoản chính xác, cập nhật và đầy đủ và cho
                                    phép chúng tôi sử dụng thông tin đó để liên lạc với bạn về Dịch vụ của chúng tôi. Thông tin liên lạc của
                                    chúng tôi với bạn bằng cách sử dụng thông tin Tài khoản của bạn sẽ đáp ứng mọi yêu cầu về thông báo pháp
                                    lý.
                                </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Bạn không được chia sẻ thông tin đăng nhập Tài khoản, thông tin đăng nhập hoặc mã thông báo truy cập của
                                    mình với bất kỳ ai khác. Bạn cũng không được cung cấp Tài khoản của mình cho bất kỳ ai khác. Bạn chịu
                                    trách nhiệm về mọi hoạt động xảy ra trong Tài khoản của mình và bạn đồng ý thông báo cho chúng tôi ngay
                                    lập tức nếu bạn biết về bất kỳ quyền truy cập trái phép nào vào Tài khoản của mình bằng cách gửi email
                                    đến youteach.hcm@gmail.com.
                                </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Bạn có thể đóng Tài khoản của mình bất kỳ lúc nào bằng cách liên hệ với chúng tôi tại
                                    youteach.hcm@gmail.com.
                                </Typography>
                                <Typography variant="h4">Sử dụng Dịch vụ của chúng tôi:</Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    <em>Sử dụng được phép: </em>Bạn có thể truy cập và sử dụng Dịch vụ của chúng tôi chỉ tuân theo những
                                    Điều khoản, Chính sách Quyền riêng tư của chúng tôi và mọi hướng dẫn hoặc điều khoản bổ sung chúng tôi
                                    có thể đăng trên Dịch vụ (gọi là "Sử dụng được phép"). Bạn không được truy cập hoặc sử dụng hoặc giúp đỡ
                                    người khác truy cập hoặc sử dụng Dịch vụ của chúng tôi theo những cách sau:
                                </Typography>
                                <ul style={{ listStyleType: 'disc', marginLeft: '4rem' }}>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Bằng bất kỳ cách nào vi phạm bất kỳ luật hoặc quy định hiện hành nào—bao gồm, nhưng không giới
                                            hạn, bất kỳ luật nào về sở hữu trí tuệ, quyền riêng tư, bảo vệ dữ liệu, kiểm soát xuất khẩu hoặc
                                            bảo vệ người tiêu dùng.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Tạo hoặc chia sẻ bất kỳ nội dung nào trái pháp luật, có hại, lạm dụng, quấy rối, phỉ báng, tục
                                            tĩu, thô tục, hận thù, phân biệt đối xử hoặc có thể bị phản đối.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Tạo hoặc chia sẻ bất kỳ nội dung nào vi phạm, lạm dụng hoặc xâm phạm quyền sở hữu trí tuệ hoặc
                                            quyền pháp lý khác của bất kỳ người hoặc tổ chức nào.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Tạo hoặc chia sẻ bất kỳ nội dung nào chứa thông tin cá nhân của người khác mà không có sự đồng ý
                                            của họ, hoặc giả mạo hoặc biểu diễn sai về danh tính hoặc liên kết của bạn.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Tạo hoặc chia sẻ bất kỳ nội dung nào khuyến khích hoặc ủng hộ bất kỳ hoạt động, sản phẩm, dịch
                                            vụ hoặc tổ chức bất hợp pháp hoặc gian lận.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Tạo hoặc chia sẻ bất kỳ nội dung nào chứa virus, phần mềm độc hại hoặc nội dung có thể gây trục
                                            trặc hoặc đe dọa tính bảo mật của Dịch vụ của chúng tôi hoặc bất kỳ thiết bị, mạng hoặc hệ thống
                                            nào của bất kỳ người dùng hoặc bên thứ ba.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Phân tích, cào, hoặc khai thác dữ liệu hoặc thông tin từ Dịch vụ của chúng tôi ngoại trừ những
                                            trường hợp được phép dưới những Điều khoản này.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Sử dụng Dịch vụ hoặc nội dung để truy cập không được ủy quyền vào bất kỳ hệ thống hoặc thông tin
                                            nào, hoặc lừa dối bất kỳ người nào khác.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Tham gia vào bất kỳ hành vi nào khác hạn chế hoặc làm cản trở bất kỳ người nào khác sử dụng hoặc
                                            tận hưởng Dịch vụ của chúng tôi, hoặc theo quyết định riêng của chúng tôi, khiến chúng tôi—hoặc
                                            bất kỳ người dùng, đối tác liên kết hoặc bên thứ ba nào khác—phải chịu bất kỳ trách nhiệm, thiệt
                                            hại hoặc tổn thất nào, bao gồm cả tổn thất uy tín.
                                        </Typography>
                                    </li>
                                </ul>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Bạn cũng không được lạm dụng, gây hại, can thiệp hoặc làm gián đoạn Dịch vụ của chúng tôi, bao gồm, ví
                                    dụ, việc đưa virus hoặc phần mềm độc hại vào, gửi thư rác (spamming) hoặc tấn công Dịch vụ của chúng
                                    tôi.
                                </Typography>
                                <Typography variant="h4">Các tài liệu nội dung: </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Cung cấp tài liệu đầu vào: Bạn có thể được phép gửi văn bản, hình ảnh, âm thanh, video hoặc các vật liệu
                                    khác cho Dịch vụ của chúng tôi để xử lý. Dịch vụ của chúng tôi có thể tạo ra các đầu ra dựa trên tài
                                    liệu đầu vào của bạn (chúng tôi gọi là "Outputs"). Các tài liệu này được gọi là "Nội dung".
                                </Typography>
                                <ul style={{ listStyleType: 'disc', marginLeft: '4rem' }}>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Thông tin cá nhân: Bạn nhận thức rằng Chính sách Quyền riêng tư của chúng tôi quản lý việc sử
                                            dụng và xử lý bất kỳ thông tin cá nhân nào bạn gửi cho chúng tôi liên quan đến việc sử dụng Dịch
                                            vụ, dù là một phần của Dữ liệu đầu vào hoặc không.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Quyền về Nội dung: Bạn chịu trách nhiệm với tất cả Dữ liệu đầu vào bạn gửi cho Dịch vụ của chúng
                                            tôi. Bằng cách gửi Dữ liệu đầu vào cho Dịch vụ của chúng tôi, bạn tuyên bố và đảm bảo rằng bạn
                                            có tất cả các quyền, giấy phép và sự cho phép cần thiết để chúng tôi xử lý Dữ liệu đầu vào dưới
                                            Điều khoản của chúng tôi. Bạn cũng tuyên bố và đảm bảo rằng việc gửi Dữ liệu đầu vào cho chúng
                                            tôi sẽ không vi phạm Điều khoản, Chính sách Quyền riêng tư của chúng tôi hoặc bất kỳ luật lệ
                                            hoặc quy định nào áp dụng đối với Dữ liệu đó. Giữa bạn và YouTeach.AI, và trong phạm vi cho phép
                                            theo luật lệ áp dụng, bạn giữ lại bất kỳ quyền, tiêu đề và quyền lợi nào bạn có trong Dữ liệu
                                            đầu vào. Tuân theo Điều khoản của chúng tôi, chúng tôi chuyển giao cho bạn tất cả quyền, tiêu đề
                                            và quyền lợi—nếu có—trong Kết quả đầu ra.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant="body2" textAlign="justify">
                                            Phụ thuộc vào Kết quả: Trí tuệ nhân tạo và học máy là các công nghệ tiên tiến vẫn đang cải thiện
                                            về độ chính xác, độ tin cậy và an toàn. Khi bạn sử dụng Dịch vụ của chúng tôi, bạn nhận thức và
                                            đồng ý:
                                        </Typography>
                                        <ul style={{ listStyleType: 'circle', marginLeft: '2rem' }}>
                                            <li>
                                                <Typography variant="body2" textAlign="justify">
                                                    Kết quả có thể không luôn chính xác và có thể chứa đựng những sai lầm về nội dung, ngay
                                                    cả khi chúng có vẻ chính xác do độ chi tiết hoặc cụ thể của chúng.
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body2" textAlign="justify">
                                                    Bạn không nên dựa vào bất kỳ Kết quả nào mà không xác nhận độ chính xác và sự phù hợp
                                                    của chúng với mục đích dự định của bạn.
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body2" textAlign="justify">
                                                    Dịch vụ và bất kỳ Kết quả nào có thể không phản ánh thông tin đúng, hiện tại hoặc đầy
                                                    đủ.
                                                </Typography>
                                            </li>
                                            <li>
                                                <Typography variant="body2" textAlign="justify">
                                                    Kết quả có thể chứa nội dung không nhất quán với quan điểm của YouTeach.AI.
                                                </Typography>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <Typography variant="h4">Kết thúc và Chấm Dứt:</Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Chúng tôi có quyền chấm dứt hoặc tạm ngừng Dịch vụ của bạn hoặc quyền truy cập của bạn vào Dịch vụ, mà
                                    không cần thông báo trước, nếu chúng tôi cho rằng bạn đã vi phạm Điều khoản hoặc Chính sách Quyền riêng
                                    tư của chúng tôi, hoặc nếu chúng tôi quyết định chấm dứt hoặc tạm ngừng Dịch vụ của mình.
                                </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Bạn có thể chấm dứt tài khoản của mình bất kỳ lúc nào bằng cách liên hệ với chúng tôi qua email
                                    youteach.hcm@gmail.com. Chấm dứt tài khoản của bạn sẽ dẫn đến mất mọi quyền lợi, chế độ và ưu đãi của
                                    bạn trong Dịch vụ ngay lập tức.
                                </Typography>
                                <Typography variant="h4">Thay Đổi Điều khoản:</Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Chúng tôi có thể thay đổi Điều khoản này theo thời gian. Chúng tôi sẽ thông báo cho bạn về bất kỳ thay
                                    đổi nào bằng cách đăng thông báo trên trang web của chúng tôi hoặc thông qua Dịch vụ của chúng tôi. Bạn
                                    đồng ý rằng việc tiếp tục sử dụng Dịch vụ sau khi những thay đổi này có hiệu lực đồng nghĩa với việc bạn
                                    chấp nhận Điều khoản mới. Nếu bạn không đồng ý với những thay đổi này, bạn nên ngưng sử dụng Dịch vụ của
                                    chúng tôi.
                                </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Nếu bạn có bất kỳ câu hỏi hoặc nghi ngờ nào về Điều khoản này, vui lòng liên hệ với chúng tôi qua
                                    youteach.hcm@gmail.com.
                                </Typography>
                                <Typography variant="body2" textAlign="justify" style={{ textIndent: '2rem' }}>
                                    Xin chân thành cảm ơn bạn đã tin dùng dịch vụ của YouTeach.AI. Chúng tôi cam kết tiếp tục nỗ lực để mang
                                    đến cho bạn trải nghiệm phong phú nhất và dịch vụ chất lượng cao nhất. Hãy tiếp tục theo dõi và đồng
                                    hành cùng chúng tôi trong hành trình đầy ý nghĩa của bạn.
                                </Typography>
                            </Stack>
                        </MainCard>
                    </Grid>
                </Grid>
            </Container>
            <SectionWrapperFooter
                sx={{ bgcolor: theme.palette.mode === 'dark' ? 'background.default' : theme.palette.main.lightItems, pb: 0 }}
            >
                <FooterSection />
            </SectionWrapperFooter>
        </HeaderWrapper>
    );
};

export default TermOfUse;
